import React, { useState } from 'react';
import { useMutation } from '@common/hooks';
import { createMessage } from 'works/legacy/lib/message-helper';
import {
  DisputeExportArgs,
  DisputeExportMutation,
  DisputeExportResponse,
} from '@pay-bill/graphql';
import { TabularExportButton } from '@pay-bill/components';

export const DisputeExportButton = ({
  entityId,
  entityType,
  disputeIds,
  onFinish,
}: {
  entityId?: string;
  entityType?: 'invoice' | 'reverse_invoice';
  disputeIds?: string[];
  onFinish?: () => void;
}) => {
  const [loading, setLoading] = useState(false);
  const [performExport] = useMutation<DisputeExportResponse, DisputeExportArgs>(
    DisputeExportMutation,
    {
      onCompleted: (response) => {
        setLoading(false);
        const { downloadUrl } = response.result.file;
        if (downloadUrl) {
          window.location.href = downloadUrl;
        }

        createMessage('success', `Disputes downloaded.`);
        onFinish?.();
      },
      onError: () => {
        setLoading(false);
        createMessage('error', 'Download failed. Please try again.');
      },
    }
  );

  const exportFile = (format: 'tsv' | 'csv' | 'xlsx') => {
    setLoading(true);
    void performExport({
      variables: {
        input: {
          entityId,
          entityType,
          format,
          disputeIds,
        },
      },
    });
  };

  return (
    <TabularExportButton
      loading={loading}
      onExport={exportFile}
      placement="topRight"
    >
      Export
    </TabularExportButton>
  );
};
